/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import * as React from "react";
import { IconSize, SmallCross } from "@blueprintjs/icons";
import { Classes, DISPLAYNAME_PREFIX } from "../../common";
export var TagRemoveButton = function (props) {
    var className = props.className, large = props.large, onRemove = props.onRemove, tabIndex = props.tabIndex;
    var isLarge = large || (className === null || className === void 0 ? void 0 : className.includes(Classes.LARGE));
    var handleRemoveClick = React.useCallback(function (e) {
        onRemove === null || onRemove === void 0 ? void 0 : onRemove(e, props);
    }, [onRemove, props]);
    return (React.createElement("button", { "aria-label": "Remove tag", type: "button", className: Classes.TAG_REMOVE, onClick: handleRemoveClick, tabIndex: tabIndex },
        React.createElement(SmallCross, { size: isLarge ? IconSize.LARGE : IconSize.STANDARD })));
};
TagRemoveButton.displayName = "".concat(DISPLAYNAME_PREFIX, ".TagRemoveButton");
//# sourceMappingURL=tagRemoveButton.js.map